<template>
  <div id="offersSlider" class="offers-slider home-slider">
    <a v-for="galleryBanner in gallery_banners" :href="galleryBanner.link" :title="galleryBanner.title"
       class="offers-slider__link">
      <picture>
        <source :srcset="galleryBanner.mobile_image.webp" media="(max-width: 767px)" type="image/webp">
        <source :srcset="galleryBanner.desktop_image.webp" type="image/webp">
        <img :alt="galleryBanner.title" :src="galleryBanner.desktop_image.source" data-sizes="auto" width="300" height="300" class="img lazyload">
      </picture>
    </a>
  </div>
</template>
<script>
export default {
  name:  "BannerGallery",
  props: [
    'gallery_banners'
  ],

  mounted() {
    this.activateSlick();
  },
  methods: {

    /**
     * Activate the Slick slider.
     *
     * @method
     */
    activateSlick() {
      $("#offersSlider").slick({
        infinite:       true,
        slidesToShow:   1,
        slidesToScroll: 1,
        arrows:         true,
        dots:           true,
        fade:           true,
        speed:          600,
        autoplay:       true,
        autoplaySpeed:  3000,
        lazyLoad:       'ondemand',
      });
    }
  },
}
</script>